export enum LOGIN_STATE {
	INITIAL,
	MAIL_SENDING,
	MAIL_SENT,
	LINK_CLICKED,
	LOGGED_IN,
}
